import React from 'react';
import {Tooltip} from "antd";
import {InfoCheckIcon, InfoIcon, PrivateCircleIcon, SettingsIcon} from "../../../image";
import {useTranslation} from "react-i18next";
import './TooltipSettingAutoChains.scss';
import {isDateInPast} from "../../../utils/helperFunctions";
import Text from '../../Text/Text'

const TooltipSettingAutoChains = (props) => {
	const {data, onClick} = props;
	const {t} = useTranslation();

	if(isDateInPast(data.datetime_start)){
		return (
			<SettingsIcon
				style={{color: data?.video_id ? '#1ABB78' : '#9898A6'}}
				className={"tooltip-settings-auto-chain"} onClick={(e) => {
				if(data?.video_id){
					onClick(e)
				}
			}}/>
		)
	}else if(String(data?.preset?.is_auto) === 'true'){
		return (
			<Tooltip placement="top" title={t('tooltip_auto_settings_chains')}>
				<div className={"tooltip-settings-container"} onClick={() => onClick(data?.id)}>
					<InfoIcon className={"tooltip-settings-auto-chain"}/>
					<Text size="f10" color="#FFA800">{t('auto_sharing')}</Text>
				</div>
			</Tooltip>
		)
	}else if(String(data?.preset?.is_auto) === 'false'){
		return (
			<Tooltip placement="top" title={t('tooltip_manual_settings_chains')}>
				<div className={"tooltip-settings-container"} onClick={() => onClick(data?.id)}>
					<InfoCheckIcon className={"tooltip-settings-auto-chain"} />
					<Text size="f10" color="#1ABB78">{t('custom_sharing')}</Text>
				</div>
			</Tooltip>
		)
	}else{
		return (
			<Tooltip placement="top" title={t('tooltip_not_select_settings_chains')}>
				<div className={"tooltip-settings-container"} onClick={() => onClick(data?.id)}>
					<PrivateCircleIcon className={"tooltip-settings-auto-chain--manual"}/>
					<Text size="f10" color="#84848F">{t('no_sharing')}</Text>
				</div>
			</Tooltip>
		);
	}

};

export default TooltipSettingAutoChains;